import { MessageBusService } from '../shared/message-bus';
import { Subscription } from 'rxjs';
import { Injectable } from '@angular/core';
import { ToastrService } from 'ngx-toastr';

export enum ToastTypes {
  Info = 'info',
  Warning = 'warning',
  Error = 'error',
  Success = 'success'
}

export interface ToastConfig {
  message: string;
  type?: ToastTypes;
  displayTime?: number;
}

@Injectable({providedIn: 'root'})
export class ToastService {
  config: ToastConfig;
  subscription: Subscription;

  constructor(private toastr: ToastrService, messageBus: MessageBusService) {
    this.subscription = messageBus.messages.subscribe(msg => {
      if (msg && msg.type && msg.message) {
        this.show({ message: msg.message, type: msg.type });
      }
    });
  }

  show(config: ToastConfig) {
    config.message = config.message || '...';
    config.type = config.type || ToastTypes.Info;
    config.displayTime = config.displayTime || (config.type === ToastTypes.Error ? 4000 : 2000);
    if (config.type === ToastTypes.Error) { config.type = ToastTypes.Error; }
    this.toastr.show(config.message, null, { timeOut: config.displayTime }, config.type);
  }
}
